module.exports = __webpack_public_path__ + "static/case-profile-c08f907b9ffa16cd1cd36ebd31e10ce0.png";